<template>
  <bg-style v-imloading="loading" class="recharge-widget overflow-x-auto" :class="{ 'is-mobile': device === DeviceEnum.MOBILE }"
    :style="getStyle" :mobile-bg="model.mobileBackground" :bg="model.background">
    <module-block>
      <div class="recharge-widget__content relative">
        <rich-text v-if="model.titleVisible" v-model="model.title" :stroke.sync="model.titleStroke"
          class="mb-5 recharge-activity__title" :editing="editing" :disabled="!editing" placement="bottom"
          theme="snow" />
        <div class="recharge-widget__content__list" :class="{ 'scale-mode': scaleMode }">
          <template v-for="(item, index) in cardList">
            <div
              v-if="editing || (!editing && valuesMap[item.faceId]?.value) || (!editing && valuesMap[item.faceId]?.type === 2) || item.placeholder"
              :key="`${index}-${item.faceId}`" class="item-box" :class="{ 'invisible': item.placeholder }">
              <bg-style :bg="item.background" :radius="model.radius" class="item"
                :style="getTextColor(item.faceColor, item.faceColorShow)" @click.native="handlePay(item)">
                <img v-if="valuesMap[item.faceId]?.corner" class="corner" :src="valuesMap[item.faceId]?.corner" alt />
                <template v-if="valuesMap[item.faceId]?.type === 1">
                  <div class="thumb">
                    <img v-if="checkShowActivityFlag(item)" class="activity-flag"
                      :src="model.activityFlag.backgroundImage" alt @click.stop="openGiftDetail(item)" />
                  </div>
                  <div class="relative price" :data-recharge-id="item.faceId">
                    <span>{{ getPrice(item.faceId) }}</span>
                    <template v-if="getFreePrice(item.faceId)">
                      <span>+</span>
                      <span>{{ getFreePrice(item.faceId) }}</span>
                    </template>
                  </div>
                  <div class="name relative">
                    <div>{{ getName(item.faceId) }}</div>
                  </div>
                  <div class="buy-btn">
                    <span v-if="!editing">{{ currencyLabel }}</span>
                    <span>{{ getLocalStringPrice(item.faceId) }}</span>
                  </div>
                </template>
                <template v-else-if="valuesMap[item.faceId]?.type === 2">
                  <div class="thumb">
                    <img v-if="hasGifsCard" class="activity-flag" :src="model.activityFlag.backgroundImage" alt @click.stop="openGiftDetail(item)" />
                  </div>
                  <div class="price flex justify-center items-center" :data-recharge-id="item.faceId">
                    <span>{{ anyValue || 0 }}</span>
                    <template v-if="anyValueFree">
                      <span>+</span>
                      <span>{{ anyValueFree }}</span>
                    </template>
                  </div>
                  <div class="name relative">
                    <div>{{ getName(item.faceId) }}</div>
                  </div>
                  <div class="input-box">
                    <div class="currency-label" :class="{ 'has-value': anyValue }">{{ currencyLabel }}</div>
                    <input v-model="anyValue" class="relative price-input" :class="{ 'has-value': anyValue }"
                      :placeholder="$t('siteBuild.enterAmount')" @keyup="onAnyValueInput" @click.stop
                      @focus="onAnyValueInput" @blur="onAnyValueBlur" />
                  </div>
                </template>
              </bg-style>
            </div>
          </template>
        </div>
        <rich-text v-model="model.activityTitle" class="recharge-activity__mobile-title mt-5"
          :stroke.sync="model.titleStroke" :disabled="!editing" :editing="editing" theme="snow" />
        <div v-if="model.handleButtonVisible" class="mt-4 recharge-activity__handle mx-auto" @click="handleButtonClick">
          <span>{{ model.handleButtonText }}</span>
          <img v-if="model.handleButtonIcon.backgroundImageShow" class="icon"
            :src="model.handleButtonIcon.backgroundImage" alt="">
        </div>
      </div>
    </module-block>
    <desk-pay-modal v-if="deskPay.visible" :desk-pay="deskPay" :lang-id-data="$store.state.locale.langIdData"
      @close="closePayModal" />
    <gift-detail ref="giftDetail" :data="currentRow" :amount="anyValue" />
  </bg-style>
</template>

<script>
import { mapState } from 'vuex'
import { Message } from "element-ui"
import cloneDeep from "lodash.clonedeep"
import Bus from '~/site/model/bus'
import tools, {
  formatSpePrice,
  getTextColor,
  checkUser,
  checkIgnoreMessage,
  generateOrderParams,
  sleep,
  generatePayUrl, navTo, getLangIdI18n
} from '~/utils'
import { RechargeAnyValueId } from '~/enums/siteEnum'
import { DeviceEnum } from "~/enums/deviceEnum"
import DeskPayModal from "~/components/pay/deskPayModal.vue"
import RichText from '~/components/richText/index.vue'
import ModuleBlock from '~/components/common/ModuleBlock.vue'
import { BusEventMap, TypeData } from '~/enums/data'
import { getIpInfo } from '~/site/core'
import GiftDetail from './components/giftDetail.vue'
import moment from 'moment/moment'
import { isBuildWebSite } from '~/config'

export default {
  name: 'RechargeWidget',
  components: {
    ModuleBlock,
    RichText,
    DeskPayModal,
    GiftDetail
  },
  props: {
    device: {
      type: String,
      default: ''
    },
    site: Object,
    editing: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      awaitItem: null,
      RechargeAnyValueId,
      getTextColor,
      orderLoading: false,
      currentGoods: null,
      loading: false,
      currentRow: {},
      anyValue: null,
      scaleMode: false,
      currentType: null,
      activityRes: {
        activity_rule: {
          quota: 0
        }
      },
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
    }
  },
  computed: {
    anyValueFree() {
      let value
      const number = Number(String(this.anyValue)?.replaceAll(',', '')?.replaceAll('.', '') || 0) * this.discount
      if ((number > 0) && !this.editing) {
        value = formatSpePrice(number)
      }
      return value
    },
    discount() {
      return this.$store.state.project.newRechargeActivity.percent / 100
    },
    DeviceEnum() {
      return DeviceEnum
    },
    currency() {
      return tools.getLangByip(this)
    },
    ...mapState({
      userInfo: (state) => state.user.siteUserInfo
    }),
    currencyLabel() {
      return this.$store.state.project.currencieMap[this.currency.currency]?.label
    },
    awaitGoods() {
      return this.$store.state.site.awaitGoods
    },
    valuesMap() {
      return this.$store.getters.newRechargeValuePriceSettingMap
    },
    getStyle() {
      return {
        '--recharge-column': this.model.column,
        '--recharge-mobile-column': this.model.mobileColumn,
        '--face-color': getTextColor(this.model.faceColor).color,
        '--name-color': getTextColor(this.model.nameColor).color,
        '--button-bg-color': getTextColor(this.model.buttonBackground).color,
        '--button-text-color': getTextColor(this.model.buttonColor).color,
        '--card-radius-px': this.model.radius + 'px',
        '--card-shadow-px': this.model.boxShadow + 'px'
      }
    },
    hasActivityFlagImage() {
      return this.model.activityFlag?.backgroundImage && this.model.activityFlag?.backgroundImageShow
    },
    hasGifsCard() {
      let result = false
      for (let i = 0; i < this.cardList.length; i++) {
        const current = this.cardList[i]
        if (this.getCurrentFaceValue(current.faceId)?.gifts?.length) {
          result = true
          break
        }
      }
      return result && this.hasActivityFlagImage
    },
    cardList() {
      const list = cloneDeep(this.model.list)
      if (this.$store.getters.isMobile) {
        let number = list.length / 3
        while (!Number.isInteger(number)) {
          list.push({ placeholder: true })
          number = list.length / 3
        }
        return list
      } else {
        return list
      }
    },
    isKr() {
      return this.currency.country === 'KR'
    }
  },
  beforeDestroy() {
    Bus.$off('reloadGood')
  },
  async mounted() {
    await this.init()
    Bus.$on('reloadGood', (type) => {
      const isLogin = type === BusEventMap.Login
      if (isLogin) {
        this.checkBuy()
      } else {
        this.init()
      }
    })
    this.checkBuy()
  },
  methods: {
    checkShowActivityFlag(item) {
      const current = this.getCurrentFaceValue(item.faceId)
      return current.gifts?.length > 0 && this.hasActivityFlagImage
    },
    getCurrentFaceValue(faceId) {
      return this.$store.state.project.newRechargeValueList.find(item => item.id === faceId) || {}
    },
    async openGiftDetail(item) {
      await checkUser(this, () => {
        this.$store.commit('site/SET_AWAIT_GOODS', { modelId: this.model.id, type: 'view', data: cloneDeep(item) })
      })
      const faceId = this.awaitGoods?.data?.faceId || item.faceId
      this.currentRow = cloneDeep(this.getCurrentFaceValue(faceId))
      this.$store.commit('site/SET_AWAIT_GOODS', null)
      await this.$nextTick()
      this.$refs?.giftDetail?.open()
    },
    async getActivityData() {
      const now_stem = Math.floor(moment().utc().valueOf() / 1000)
      const [err, res] = await this.$utils.to(this.$api.activity.getActivityList({
        now_time: now_stem,
        player_id: (this.userInfo?.uid || '').trim(),
        project_id: this.$store.state.project?.projectId,
        activity_type: 6,
        status: 2
      }, { editing: this.editing }))
      if (!err && res?.list) {
        const data = cloneDeep(res?.list?.[0] || {})
        data.activity_rule = JSON.parse(data.activity_rule)
        this.activityRes = data
        this.$store.commit('project/SET_RECHARGE_ACTIVITY', data.activity_rule)
      }
    },
    async getActivityCurrentValue() {
      const project_id = this.userInfo && this.userInfo.project_id
      if (!project_id) return
      const isSandBox = !isBuildWebSite
      const params = {
        sandbox: Number(isSandBox),
        currency: this.currency.currency,
        project_id,
        player_id: (this.userInfo?.uid || '').trim(),
        activity_id: this.activityRes.biz_id,
        activity_type: 6
      }
      const [err, res] = await this.$utils.to(this.$api.activity.getRechargeCurrentValue(params))
      if (!err) {
        this.$store.commit('project/SET_RECHARGE_STATIC', res)
      }
    },
    onAnyValueInput() {
      this.anyValue = this.anyValue ? Number(String(this.anyValue).replace(/^(0+)|[^\d]+/g, '')) : ''
    },
    onAnyValueBlur() {
      const formatValue = Number(String(this.anyValue).replace(/^(0+)|[^\d]+/g, ''))
      if (this.isKr) {
        this.anyValue = this.anyValue ? formatValue?.toLocaleString() : ''
      } else {
        this.anyValue = this.anyValue ? formatValue : ''
      }
    },
    checkBuy() {
      const isAim = this.awaitGoods && (this.awaitGoods.modelId === this.model.id)
      const isView = isAim && this.awaitGoods?.type === 'view'
      if (isView) {
         this.openGiftDetail()
      } else if (isAim) {
        this.createOrder(this.awaitGoods.data)
      }
    },
    handleButtonClick() {
      if (!this.editing) {
        navTo(this, this.model.pilot)
      }
    },
    closePayModal() {
      this.$store.commit('site/SET_AWAIT_GOODS', null)
      Bus.$emit('reloadActivity', BusEventMap.Payment)
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
      this.init()
    },
    async handlePay(record) {
      if (this.editing) return
      const item = this.valuesMap[record.faceId]
      const isAny = item.type === 2
      const anyValue = String(this.anyValue || 0)?.replaceAll(',', '')?.replaceAll('.', '')
      const params = isAny ? {
        value: Number(anyValue),
        rechargeId: item.recharge_id,
        id: item.id
      } : item
      if (this.orderLoading) return
      if (isAny && !(+anyValue)) return
      this.currentGoods = params
      await checkUser(this, () => {
        this.$store.commit('site/SET_AWAIT_GOODS', { modelId: this.model.id, data: cloneDeep(this.currentGoods) })
      })
      await this.createOrder(params)
    },
    getFreePrice(id) {
      const item = this.valuesMap[id]
      const price = item.value || 0
      let result = null
      const value = Number(price * this.discount)
      if ((value > 0) && !this.editing) {
        result = formatSpePrice(value)
      }
      return result
    },
    async createOrder(record) {
      this.orderLoading = true
      const [err, res] = await this.$utils.to(generateOrderParams(this, record || this.currentGoods, TypeData.recharge))
      this.orderLoading = false
      await sleep(500)
      if (!err) {
        this.$store.commit('site/SET_AWAIT_GOODS', null)
        generatePayUrl(res, this)
      } else {
        !checkIgnoreMessage(err) && Message.error(err)
      }
    },
    getLocalStringPrice(id) {
      const isKr = this.currency.country === 'KR'
      const price = Number(this.getPrice(id))
      return (isKr && !this.editing) ? price.toLocaleString() : (isNaN(price) ? this.getPrice(id) : price)
    },
    getPrice(id) {
      let result = 'No Price'
      const valueItem = this.$store.getters.newRechargeValuePriceSettingMap[id]
      if (!this.editing && valueItem) {
        result = `${valueItem.value}`
      }
      return result
    },
    getName(id) {
      let result = 'No Name'
      const item = this.valuesMap[id]
      if (item) {
        result = getLangIdI18n({ lang_id: item.configName }, this.$store.state.locale.langIdData)
      }
      return result
    },
    checkMaxValueLayout() {
      const list = this.$store.state.project.newRechargeValueList
      const valueArr = this.model.list?.map(item => {
        return list.find(dataItem => dataItem.id === item.faceId)?.value || 0
      })
      const max = Math.max(...valueArr)
      const faceId = list.find(item => item.value === max)?.id
      const containerWidth = document.querySelector('.recharge-widget__content__list .item')?.offsetWidth
      const childList = document.querySelector('div[data-recharge-id="' + faceId + '"]')?.children || []
      if (childList?.length) {
        let width = null
        for (let i = 0; i < childList.length; i++) {
          const item = childList[i]
          width += item.offsetWidth
        }
        this.scaleMode = width > containerWidth
      }
    },
    async init() {
      this.loading = true
      await getIpInfo(this)
      await this.$store.dispatch('project/getNewRechargeValues', this)
      await this.$nextTick()
      this.loading = false
      this.checkMaxValueLayout()
    }
  }
}
</script>

<style scoped lang="less">
.recharge-widget {
  padding: 20px 0;

  &__content {
    &__list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 84px;

      &.scale-mode {
        .item {

          .buy-btn,
          .price-input,
          .currency-label {
            font-size: 18px;
          }

          .price {
            font-size: 14px;
            margin: 8px 0;
          }

          .thumb {
            height: 200px;
          }
        }
      }

      .item {
        width: 240px;
        height: 340px;
        cursor: pointer;
        box-shadow: 0 0 var(--card-shadow-px) rgba(0, 0, 0, 0.2);

        .corner {
          z-index: 90;
          position: absolute;
          width: 100px;
          top: -18px;
          left: -6px;
        }

        .thumb {
          height: 200px;
          position: relative;

          .activity-flag {
            position: absolute;
            bottom: 22px;
            right: -2px;
            height: 40px;
          }
        }

        .price {
          font-size: 18px;
          font-weight: bold;
          position: relative;
          color: var(--name-color);
          text-align: center;
          margin: 4px 0;
          padding-top: 2px;
          white-space: nowrap;
        }

        .name {
          text-align: center;
          margin-top: 0;
          color: var(--name-color);
          font-size: 18px;
          font-weight: bold;
          line-height: 1;
        }

        .buy-btn {
          margin: 12px 20px 0 20px;
          height: 56px;
          background: var(--button-bg-color);
          position: relative;
          border-radius: var(--card-radius-px);
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          color: var(--button-text-color);
        }

        .input-box {
          margin: 12px 20px 0 20px;
          position: relative;
          display: flex;

          .currency-label {
            color: white;
            font-size: 24px;
            font-weight: bold;
            background-color: rgb(148, 148, 148);
            padding: 0 10px;
            line-height: 56px;
            transition: linear 0.24s background;
            border-radius: var(--card-radius-px) 0 0 var(--card-radius-px);

            &.has-value {
              background-color: var(--button-bg-color);
            }
          }

          .price-input {
            .buy-btn();
            width: 100%;
            background: rgb(148, 148, 148);
            margin: 0;
            outline: none;
            border-radius: 0 var(--card-radius-px) var(--card-radius-px) 0;
            transition: linear 0.24s background;

            &::placeholder {
              color: white;
            }

            &.has-value {
              background: var(--button-bg-color);
            }
          }
        }
      }
    }

    .recharge-activity__handle {
      padding: 10px 20px;
      background-color: var(--button-bg-color);
      color: var(--button-text-color);
      width: fit-content;
      cursor: pointer;
      border-radius: var(--card-radius-px);
      display: flex;
      align-items: center;

      .icon {
        width: 20px;
        height: 20px;
        margin-left: 10px;
      }
    }
  }

  &.is-mobile {
    padding: 10px;

    .recharge-widget__content {
      width: 100%;

      .recharge-activity__title {
        padding: 0 12px;
      }

      .recharge-activity__mobile-title {
        padding: 0 12px;
      }

      &__list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        grid-template-columns: repeat(3, 1fr);
        gap: 15px 0;
        padding: 0 5px;

        &.scale-mode {

          .name,
          .price,
          .buy-btn,
          .currency-label,
          .price-input {
            font-size: 10px !important;
          }

          .thumb {
            height: 95px !important;
          }

          div.price {
            margin: 5px 0 3px 0;
          }

          .price-input {
            &::placeholder {
              font-size: 10px;
              position: unset !important;
            }
          }
        }
      }

      .item-box {
        display: flex;
        justify-content: center;
      }

      .item {
        width: 110px;
        height: 160px;

        .corner {
          width: 60px;
          top: -10px;
          left: -4px;
        }

        .thumb {
          height: 88px;

          .activity-flag {
            width: 36px;
            bottom: 4px;
          }
        }

        .name {
          font-size: 12px;
        }

        .price {
          font-size: 14px;
          margin: 8px 0 3px 0;
          line-height: 1;
        }

        .buy-btn {
          margin: 5px 15px 0 15px;
          height: 22px;
          font-size: 14px;
        }

        .input-box {
          margin: 5px 15px 0 15px;

          .currency-label {
            line-height: 22px;
            font-size: 14px;
            padding: 0 5px;
          }

          .price-input {
            .buy-btn();
            width: 100%;
            margin: 0;
            height: 22px;
            font-size: 14px;

            &::placeholder {
              font-size: 10px;
              position: relative;
              top: -2px;
            }
          }
        }
      }
    }

    .recharge-activity__handle {
      height: 26px;
      padding: 0 20px;
    }
  }
}
</style>
